import { render } from "./index-2.vue?vue&type=template&id=2b0671ae"
import script from "./index-2.vue?vue&type=script&lang=ts"
export * from "./index-2.vue?vue&type=script&lang=ts"
script.render = render

export default script